import { getRequest, postRequest } from 'utils/httpServices';

class User {
  static info = (queryData = {}, config = {}) => {
    return getRequest(`v2/dashboard/profile/partner-profile-details`, queryData, config).catch(
      (error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400
      })
    );
  };

  static logout = (queryData = {}, config = {}) => {
    return postRequest(`v1/logout `, queryData, config).catch((error) => ({
      success: false,
      data: (error.response && error.response.data) || {},
      status: (error.response && error.response.status) || 400
    }));
  };
}

export default User;
